import { useEffect } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { notification } from '@pu/mpp-ui/notifications';
import { DEFAULT_MSAL_LOGIN_REDIRECT_PARAMETERS } from 'core/constants/msal.constants';
import { Path } from 'core/constants/path.constants';
import { getAppInstanceId } from 'core/utils/app-instance-id.utils';
import { getChannel } from 'core/utils/channel.utils';
import { Loading } from 'shared/components/loading';

import './index-page.scss';

export const IndexPage = () => {
  const { search } = useLocation();
  const [searchParams] = useSearchParams();
  const isLoggedIn = useIsAuthenticated();
  const pathToRedirect = `${Path.HOME}${search}`;
  const searchParamsObject = Object.fromEntries(searchParams);
  const appInstanceId = getAppInstanceId();
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isLoggedIn) {
      try {
        const channelId = getChannel();
        instance.loginRedirect({
          ...DEFAULT_MSAL_LOGIN_REDIRECT_PARAMETERS,
          extraQueryParameters: {
            ...searchParamsObject,
            ...DEFAULT_MSAL_LOGIN_REDIRECT_PARAMETERS.extraQueryParameters,
            channelId,
            app_instance_id: appInstanceId,
          },
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('login error', error);
        notification.error(`Ocurrió un error inesperado durante el inicio de sesión`);
      }
    }
  }, [inProgress, instance]);

  if (isLoggedIn) {
    return <Navigate to={pathToRedirect} replace />;
  }

  return (
    <div className="index-page">
      <Loading />
    </div>
  );
};
